<template >
  <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
    <v-hover>
      <v-card
        color="cardBackground"
        class="pr-4 pl-3 py-2 mb-2 rounded-3"
        slot-scope="{ hover }"
        style="height:86px"
        :class="`elevation-${hover ? 5 : 2}`">
      <router-link class="no-link-style" :to="{ name: 'CaseConfig', params: {case_type_id: cardContent.id, config_tab: 'Summary'} }">
      <v-card-title class="pa-0 pb-1 pt-1">
        <v-flex shrink d-inline-block style="width:65px">
         <v-avatar color="white" size="50px">
            <font-awesome-icon
              class="secondary--text"
              size="2x"
              :icon="icon">
            </font-awesome-icon>
          </v-avatar>
          </v-flex>
          <v-flex d-inline-block style="width:calc(100% - 90px)">
            <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-4 ml-0">
              {{title}}
            </h3>
              <h4 class="text-truncate pr-0 pb-1 ">
                <span class="primary--text body-1 opacity-54 pt-1">{{description}}</span>
              </h4>
               <h4 class="text-truncate pr-0 pb-1">
                  <span v-if="cardContent.coreTemplate" class="primary-text body-1 opacity-54">
                    Visible in Casework Menu
                  </span>
                  <span v-if="!cardContent.coreTemplate" class="primary-text body-1 opacity-54">
                    Hidden from Casework Menu
                  </span>
                </h4>
          </v-flex>
          </v-card-title>
          </router-link>
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
export default {
  name: "case-template-card",
  props: ["cardContent"],
  data: () => ({ expandDetail: false }),
  computed: {
    title() { if (this.cardContent) { return this.cardContent.name } else { return undefined } },
    icon() {
      let set = 'fal'
      let icon = 'exclamation-triangle'
      if (this.cardContent && this.cardContent.iconSet) { set = this.cardContent.iconSet }
      if (this.cardContent && this.cardContent.iconCode) { icon = this.cardContent.iconCode }
      return [set, icon]
    },
    description() {
      if (this.cardContent && this.cardContent.description) { return this.cardContent.description } else { return "" }
    }
  }
}
</script>

<style>
.case--avatar {
  position: absolute;
  top: 50%;
  left: 20px;
  margin-top: -21px;
}

.case--avatar.v-avatar {
  -webkit-box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.2),
    1px 1px 5px 0px rgba(0, 0, 0, 0.2), 1px 1px 5px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.2),
    1px 1px 5px 0px rgba(0, 0, 0, 0.2), 1px 1px 5px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  transform-style: preserve-3d;
}

.case--avatar:after {
  content: "";
  height: 27px;
  width: 54px;
  background: #e5e5e5;
  display: block;
  bottom: -7px;
  right: -7px;
  position: absolute;
  z-index: -1;
  border-radius: 0 0 27px 27px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.8);
  transform: translateZ(-1px);
}

.case--avatar:before {
  content: "";
  height: 27px;
  width: 54px;
  background: rgba(0, 0, 0, 0.1);
  display: block;
  top: -7px;
  left: -7px;
  position: absolute;
  z-index: -1;
  border-radius: 27px 27px 0 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  transform: translateZ(-1px);
}
</style>
